import { FileText, BarChart2, Download, MessageSquare } from 'lucide-react';

const features = [
  {
    icon: FileText,
    title: 'Analyse automatique PDF',
    description: 'Uploadez vos documents financiers (bilan, liasses fiscales) et laissez RepriScan extraire les données clés automatiquement.',
  },
  {
    icon: BarChart2,
    title: 'Score global + compatibilité repreneur',
    description: 'Un score sur 100 qui synthétise rentabilité, risques et fit avec votre profil de repreneur.',
  },
  {
    icon: Download,
    title: 'Export PDF professionnel',
    description: 'Téléchargez une synthèse complète à partager avec votre banquier ou conseiller.',
  },
  {
    icon: MessageSquare,
    title: 'Next steps guidés',
    description: 'Questions pertinentes à poser au cédant et points à clarifier avec votre banquier.',
  },
];

export function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-card">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Fonctionnalités clés
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Tout ce dont vous avez besoin pour analyser un dossier de reprise.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="flex gap-4 p-6 rounded-xl border bg-background hover:border-accent/50 transition-colors"
            >
              <div className="shrink-0">
                <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center">
                  <feature.icon className="h-5 w-5 text-primary-foreground" />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
